import { EmailTemplateLayout } from "@rumble-it/common-lib/types/models/EmailTemplateLayout.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input } from "@rumbledirect/ui";
import { Col, Form, Row } from "antd";
import { EmailTemplateLayoutPreview } from "./EmailTemplateLayoutPreview";

interface EmailTemplateLayoutFormCardProps {
  mutation: UseMutationResult<unknown, Error, EmailTemplateLayout, unknown>;
  loading?: boolean;
  initialValues?: EmailTemplateLayout;
  title?: string;
  buttonText?: string;
}

export const EmailTemplateLayoutFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "Email Template Layout Aanmaken",
  buttonText = "Aanmaken",
}: EmailTemplateLayoutFormCardProps) => {
  const [form] = Form.useForm();
  const html = (Form.useWatch("html", form) as string | undefined) ?? "";

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Card loading={loading} title={title}>
          <Form
            form={form}
            onFinish={mutation.mutate}
            layout="vertical"
            initialValues={initialValues}
          >
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="Titel"
              name="title"
            >
              <Input />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: "Dit veld is verplicht." }]}
              label="HTML"
              name="html"
            >
              <Input.TextArea rows={10} />
            </Form.Item>
            <Form.Item label={null}>
              <Button
                loading={mutation.isPending}
                type="primary"
                htmlType="submit"
              >
                {buttonText}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      <Col span={12}>
        <EmailTemplateLayoutPreview html={html} title="Live Preview" />
      </Col>
    </Row>
  );
};
